<script>
  /**
   * The cloud of municipality dots. Reactive to:
   *   - `data` (filtered records for the active year)
   *   - `scales` (x, y, r)
   *   - `pinnedCod` (whether a muni is selected → others dimmed)
   *
   * Hover/click events bubble up via callback props so Chart.svelte can
   * own the hover/pinned state centrally.
   */
  let {
    data,
    xScale,
    yScale,
    rScale,
    pinnedCod,
    partyColor,
    onHover,
    onLeave,
    onClick
  } = $props();

  // Keyboard support: Enter / Space toggle the same as a click.
  function onKey(d, e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    onClick?.(d, e);
  }
</script>

<g class="dots">
  {#each data as d (d.munCod)}
    <circle
      class="dot"
      class:dimmed={pinnedCod != null && pinnedCod !== d.munCod}
      class:pinned={pinnedCod === d.munCod}
      cx={xScale(d.participacion_pct)}
      cy={yScale(d.margen_pct)}
      r={rScale(d.censo)}
      fill={partyColor(d.winner, d.winnerCode)}
      role="button"
      tabindex="0"
      aria-label={`${d.name || d.prov + ', municipio ' + d.munCod}. Ganador ${d.winner} con ${d.winner_pct.toFixed(1)}%. Margen ${d.margen_pct.toFixed(1)} puntos. Participación ${d.participacion_pct.toFixed(1)}%.`}
      onmouseenter={(e) => onHover?.(d, e)}
      onmousemove={(e) => onHover?.(d, e)}
      onmouseleave={(e) => onLeave?.(d, e)}
      onfocus={(e) => onHover?.(d, e)}
      onblur={(e) => onLeave?.(d, e)}
      onclick={(e) => onClick?.(d, e)}
      onkeydown={(e) => onKey(d, e)}
    ></circle>
  {/each}
</g>
